(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["our-process"] && !Shopify.designMode) return;
  try {
    
  class OurProcess extends HTMLElement {
    #index = 0;
    #desktop = window.matchMedia('(min-width: 990px)');

    connectedCallback() {
      this.addEventListener('click', this.#onClick);
      // Theme editor: show the step being edited.
      this.addEventListener('shopify:block:select', this.#onClick);
      // `toggle` doesn't bubble, so listen in the capture phase.
      this.addEventListener('toggle', this.#onToggle, true);
      this.#desktop.addEventListener('change', this.#sync);
      this.#sync();
    }

    disconnectedCallback() {
      this.#desktop.removeEventListener('change', this.#sync);
    }

    #onClick = (e) => {
      const step = e.target.closest('[data-step]');
      if (step && this.contains(step)) this.select(Number(step.dataset.step));
    };

    #onToggle = (e) => {
      const item = e.target;
      if (item.matches?.('[data-item]') && item.open) this.select(Number(item.dataset.item));
    };

    #sync = () => this.select(this.#index);

    /** Activates one step in both layouts and plays only the video that is actually visible. */
    select(index) {
      this.#index = index;
      const activeClass = this.dataset.activeClass;
      this.querySelectorAll('[data-step]').forEach((step, i) => {
        step.classList.toggle('is-active', i === index);
        step.classList.toggle(activeClass, i === index);
        step.setAttribute('aria-pressed', String(i === index));
      });
      this.querySelectorAll('[data-item]').forEach((item, i) => {
        item.classList.toggle(activeClass, i === index);
        // Also closes the others, for browsers without exclusive <details name>.
        if (item.open !== (i === index)) item.open = i === index;
      });
      this.querySelectorAll('[data-media]').forEach((media) => {
        const active = Number(media.dataset.media) === index;
        media.classList.toggle('is-active', active);
        const video = media.querySelector('video');
        if (!video) return;
        if (active && media.offsetParent !== null) video.play().catch(() => {});
        else video.pause();
      });
    }
  }

  if (!customElements.get('our-process')) customElements.define('our-process', OurProcess);

  } catch(e) { console.error(e); }
})();
})();
